import { Image } from '@chakra-ui/image';
import { Card } from 'types';
import styles from './../ContentStyles.module.css';
import classNames from 'classnames';
export interface StoryContentProps {
  content: Card;
}
const cardHtml = (cardContent: Card, html) => {
  if (!cardContent.mediaUrl) {
    return html;
  } else if (cardContent.mediaUrl) {
    return <div className={styles.storyCard}>
        <div className={styles.imageContainer}>
          <Image src={cardContent.mediaUrl as string} alt={'Story Card Image'} />
        </div>
        {html}
      </div>;
  }
};
export const StoryContent = ({
  content
}: StoryContentProps) => {
  const titleLength = content.title?.length || 0;
  const descriptionLength = content.description?.length || 0;
  const titleClasses = classNames({
    [styles.longTitle]: titleLength > 40
  });
  const descriptionClasses = classNames({
    [styles.longContent]: descriptionLength > 200
  });
  const contentClasses = classNames({
    [styles.cardContent]: true,
    [styles.longContent]: descriptionLength + titleLength > 500
  });
  const html = <div className={contentClasses}>
      <h1 className={titleClasses}>{content.title}</h1>
      <p className={descriptionClasses}>{content.description}</p>
    </div>;
  return cardHtml(content, html);
};